import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ResourceProvider } from '../../providers/resource/resource';
import { TranslateService } from '@ngx-translate/core';
import { HttpProvider } from '../../providers/http/http';
import { FormGroup } from '@angular/forms';
import { RouteProvider } from '../../providers/route/route';

@Component({
  selector: 'rmt-country',
  templateUrl: 'rmt-country.html'
})
export class RmtCountryComponent {
  @Input() placeholder: string;
  @Input() disable: boolean = false; // unfortunately we can't use the name disabled otherwise we could get reactive form warnings
  @Input() sendCountries: boolean = false;
  @Input() favorites: boolean = false;
  @Input() customCountries: string[] = null;
  @Input() customCountriesPromise = null;
  @Input() otherCountries: string[] = null;
  @Input() favoritePromise = null;
  @Input() butnId: string = '';
  @Input() newDesign: boolean = false;
  @Input() header: string;
  @Input() title: string;
  @Input() label:string;
  @Input() showListHeader?: boolean = false;
  @Input() additionalParams = null;
  @Input() hideLabel: boolean = false;
  @Input() isEditable: boolean = true;
  @Input() showOtherOption: boolean = false;
  @ViewChild('picker') picker;
  @ViewChild('input') input;
  @Output() ionChange = new EventEmitter<string>();
  @Output() onCountrySelect = new EventEmitter<any>();
  @Output() searchedText = new EventEmitter<string>();

   /**
   * The error message
  */
   @Input() errorMessage;
   @Input() defaultErrors: boolean = false;
   @Input() refFormControlError;
   @Input() hideError: boolean = false;
   @Input() showOnSubmit: boolean = false;
   @Input() submitAttempts: number = 0;
   @Input() isErrorHidden: boolean = true;
   @Input() refForm: FormGroup = null;
   @Input() formControlName: string;
   //#endregion error
  countries;
  params;

  constructor(private resourceProvider: ResourceProvider, private translate: TranslateService, private routeProvider: RouteProvider) {
    this.params = {
      header: this.translate.instant('page.priceCalculatorPage.title'),
      title: this.translate.instant('form.moneyTransferCalculatorForm.countries.label'),
      placeholder: this.translate.instant('page.languagePage.countrySearch'),
      errorTitle: this.translate.instant('page.checkPricesPage.countryNotFoundHeader'),
      errorMessage: this.translate.instant('page.checkPricesPage.countryNotFoundContent'),
      newDesign: this.newDesign,
      useIcons: true,
      itemFieldIcon: 'value',
      itemFieldIconPrefix: 'custom-icon-country-',
      items: null,
      itemsPromise: this.resourceProvider.getCountries(),
      favoritePromise: null,
      ignoreAccentsDuringSearch: true,
      titleId:'countries',
      onSelect: this.onSelectCountryFromPicker.bind(this),
    };
  }

  ngOnInit() {
    if(this.header != undefined)
      this.params.header = this.header
    if(this.title != undefined)
      this.params.title = this.title
    if (this.sendCountries)
      this.params.itemsPromise = this.resourceProvider.getSendCountries();
    if (this.favoritePromise)
      this.params.favoritePromise = this.favoritePromise;
    else if (this.favorites)
      this.params.favoritePromise = this.resourceProvider.getTopCountries();
    this.params.newDesign = this.newDesign

    const itemsPromise = this.params.itemsPromise;
    this.params.itemsPromise = new Promise(async(resolve) => {
      let countries = await itemsPromise;
      this.countries = countries;
      if (this.customCountriesPromise)
        this.customCountries = await this.customCountriesPromise;
      if (this.customCountries) {
        const indexedCountries: any = {};
        for (let i=0; i < countries.length; i++) {
          const country = countries[i];
          indexedCountries[country.value] = country;
        }

        const items = [];
        for (let i=0; i < this.customCountries.length; i++) {
          const country = this.customCountries[i];
          items.push(indexedCountries[country]);
        }

          // use localeCompare to sort the list according to the language, refer to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#sorting_non-ascii_characters
      if(HttpProvider.currentLanguage) {
        const lang = HttpProvider.currentLanguage.split("-");
        items.sort((a,b) => {
          return a.text.toUpperCase().localeCompare(b.text.toUpperCase(),lang[0]);
         });
       }

        this.params.itemsPromise = items;
        this.params.items = null;
        countries = this.params.itemsPromise;
      }
      if (this.otherCountries) {
        this.params.itemsPromise = this.otherCountries;
        this.params.items = null;
        countries = this.params.itemsPromise;
      }

      if(this.showOtherOption){
        countries.push({
          "countryCode":0,
          "text": this.translate.instant('page.countryRegisterPage.otherButton'),
          "value":"O"
        });
      }

      resolve(countries);
    });
    if (this.input.value)
      this.picker.setValue(this.input.value);
    if (this.additionalParams)
      this.params = { ...this.params, ...this.additionalParams };
  }

  setValue(value, triggerEvents: boolean = true) {
    this.picker.setValue(value, triggerEvents);
  }

  getValue() {
    return this.picker.getValue();
  }

  getCountryName() {
    return this.picker.getText();
  }

  getCountryIcon(value) {
    return 'custom-icon-country-' + value.toLowerCase();
  }

  onSelectCountryFromPicker(item, ctrl){

    if(this.onCountrySelect){
      this.onCountrySelect.emit(item);
    }

    if (item && item.value == "O"){
      const params = {
        header: this.translate.instant('page.countryRegisterPage.countryNotAvailableHeader'),
        texts: [
          this.translate.instant('page.countryRegisterPage.countryNotAvailableContent'),
        ],
        primaryButton: this.translate.instant('global.gotItButton'),
        isTextCenter: true
      }
      this.routeProvider.openActionSheet(this.routeProvider.pages.ActionsheetInfoPage, params, null, 'rmt-actionsheet-info-modal', true);
    }else{
      ctrl.dismiss(item);
    }
  }

  selectCountry(value) {
    this.input.value = value;
    if(this.refForm && this.refForm.controls && this.refForm.controls[this.formControlName]) {
      this.refForm.controls[this.formControlName].setValue(value);
    }
    this.ionChange.emit(value);
  }

  changeInput(ev) {
    if (this.picker.getValue() !== ev.value)
      this.picker.setValue(ev.value);
  }

  setCountries(countries) {
    this.params.items = countries;
    this.params.itemsPromise = null;
    this.countries = countries;
  }

  onSearchedText(event) {
    this.searchedText.emit(event)
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-country/rmt-country.ts